export default "__VITE_ASSET__fea53aae__"